module.exports = __webpack_public_path__ + "img/glip-logo.e5f094f6.svg";